
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import DoctrinePage from './pages/DoctrinePage';
import LorePage from './pages/LorePage';
import AboutAcademyPage from './pages/AboutAcademyPage';
import PerformanceMonitor from './components/PerformanceMonitor';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/doctrine" element={<DoctrinePage />} />
          <Route path="/lore" element={<LorePage />} />
          <Route path="/about" element={<AboutAcademyPage />} />
        </Routes>
        <PerformanceMonitor />
      </Router>
    </div>
  );
}

export default App;
